import { useTheme } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';

export const MyMDataGrid = (props) => {
  const { dataList, handleSortModelChange, handleFilterModelChange, isLoading, uniquyKey, sx, isDisableColumnMenu, ...other } = props;
  const theme = useTheme();
  const style = {
    // 2024.5.8 MyMine Version1.5対応 Modify Start
    '.MuiDataGrid-columnHeaders > div[role=row]': {
    // 2024.5.8 MyMine Version1.5対応 Modify End
      backgroundColor: theme.palette.background.secondary,
      color: 'white'
    },
    '.MuiDataGrid-toolbarContainer': {
      borderBottom: 'solid 1px rgba(224, 224, 224, 1)'
    },
    '.MuiDataGrid-row .MuiDataGrid-cell:not(:last-child)': {
      borderRight: 'solid 1px rgba(224, 224, 224, 1) !important'
    },
    ...sx
  }

  return (
    <DataGrid
      rows={dataList}
      getRowId={uniquyKey}
      sortingMode="server"
      onSortModelChange={handleSortModelChange}
      onFilterModelChange={handleFilterModelChange}
      loading={isLoading}
      sx={style}
      hideFooter={true}
      disableColumnMenu={isDisableColumnMenu ?? true}
      showCellRightBorder={true}
      {...other}
    />
  )
}